var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordProfile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "18px",
    viewBox: "0 0 15 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "96944D9E-E2EB-4EC2-9B40-579B65A25CA3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Meu-perfil",
    transform: "translate(-313.000000, -270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Seguran\\xE7a",
    transform: "translate(313.000000, 270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "password",
    fill: "#B4B4B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.125,18 L1.875,18 C0.841666667,18 0,17.1928 0,16.2 L0,7.8 C0,6.8072 0.841666667,6 1.875,6 L13.125,6 C14.1583333,6 15,6.8072 15,7.8 L15,16.2 C15,17.1928 14.1583333,18 13.125,18 Z M1.875,7.2 C1.53083333,7.2 1.25,7.4688 1.25,7.8 L1.25,16.2 C1.25,16.5312 1.53083333,16.8 1.875,16.8 L13.125,16.8 C13.4691667,16.8 13.75,16.5312 13.75,16.2 L13.75,7.8 C13.75,7.4688 13.4691667,7.2 13.125,7.2 L1.875,7.2 Z",
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5,6 C10.224,6 10,5.808 10,5.57142857 L10,3.42857143 C10,2.01085714 8.654,0.857142857 7,0.857142857 C5.346,0.857142857 4,2.01085714 4,3.42857143 L4,5.57142857 C4,5.808 3.776,6 3.5,6 C3.224,6 3,5.808 3,5.57142857 L3,3.42857143 C3,1.53771429 4.794,0 7,0 C9.206,0 11,1.53771429 11,3.42857143 L11,5.57142857 C11,5.808 10.776,6 10.5,6 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#B4B4B4",
    strokeWidth: 0.9,
    cx: 7.5,
    cy: 12.5,
    r: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordProfile);
export default __webpack_public_path__ + "static/media/password-profile.8f262df23930f1cd17574b3638487fe6.svg";
export { ForwardRef as ReactComponent };